import React, { Component } from 'react';

export default class Photovoltaik extends Component {

  componentDidMount() {
    try {
      window.galleryPV();
      window.adjustSubmenu();
    }
    catch (err) {
      console.log(err);
    }
  }

  render() {
    return (
      <div id="content" className="container" role="main">
        <div id="Planung u. Angebot" className="block row" data-nested="not-nested" data-containerid="" data-containercssclass="">
            <div className="col col-md-12">
              <respond-html id="html-1" description="HTML"><a name="unser-service"></a>
                <div className="section">
                  <div className="services">
                    <div className="row">
                      <div className="col-lg-12 text-center">
                        <h1 className="section-heading">Planung Ihrer Photovoltaikanlage</h1>
                        <p>Sie interessieren sich für eine Photovoltaikanlage mit Speicher? In 3 Schritten zu Ihrer individuellen Planung:</p>
                      </div>
                    </div>
                    <div className="row text-center">
                      <div className="col-md-4">
                        <span className="fa-stack fa-3x">
                          <i className="fa fa-circle fa-stack-2x text-primary"></i>
                          <i className="fa fa-file-signature fa-5 fa-stack-1x fa-inverse"></i>
                        </span>
                        <h4 className="service-heading">1. Datenaufnahme</h4>
                        <p className="text-muted">Wir möchten Sie gerne umfassend fachlich beraten und benötigen noch weitere Details. Beantworten Sie hierzu unverbindlich unsere Fragen zu Ihrer aktuellen Situation und Ihren Anforderungen. Unser Formular finden Sie über den folgenden <a href="https://form.jotform.com/241970376927367" target="blank">Link (externe Webseite)</a>: 
                          <p></p>
                          <a href="https://form.jotform.com/241970376927367" target="blank">
                            <button type="button" class="btn btn-primary btn-sm">Zum Formular</button>
                          </a>
                          <p></p>
                          </p>
                      </div>
                      <div className="col-md-4">
                        <span className="fa-stack fa-3x">
                          <i className="fa fa-circle fa-stack-2x text-primary"></i>
                          <i className="fa fa-search fa-5 fa-stack-1x fa-inverse"></i>
                        </span>
                        <h4 className="service-heading">2. Prüfung Ihrer Daten</h4>
                        <p className="text-muted">Wie geht es für Sie weiter? Nun sind wir dran! Im nächsten Schritt prüfen wir Ihre Daten. Aufgrund der aktuell hohen Nachfrage kommt es vereinzelt zu längeren Bearbeitungszeiten.</p>
                      </div>
                      <div className="col-md-4">
                        <span className="fa-stack fa-3x">
                          <i className="fa fa-circle fa-stack-2x text-primary"></i>
                          <i className="fa fa-calendar fa-5 fa-stack-1x fa-inverse"></i>
                        </span>
                        <h4 className="service-heading">3. Termin und Beratung</h4>
                        <p className="text-muted">Nach der Prüfung wird die Planung konkreter. Wir klären weitere Details telefonisch und sprechen mit Ihnen über ein grobes Budget für Ihr Projekt. Anschließend sprechen wir über die konkrete Projektierung und Auslegung Ihrer Photovoltaikanlage.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </respond-html>
            </div>
          </div>
        <div id="Unser Service" className="block row  bg-light-gray" data-nested="not-nested" data-containerid="" data-containercssclass="">
          <div
            className="col col-md-12">
            <respond-html id="html-1" description="HTML"><a name="unser-service"></a>
              <div className="section">
                <div className="services">
                  <div className="row">
                    <div className="col-lg-12 text-center">
                      <h1 className="section-heading">UNSER SERVICE</h1>
                      <hr></hr>
                    </div>
                  </div>
                  <div className="row text-center">
                    <div className="col-md-6">
                      <span className="fa-stack fa-3x">
                        <i className="fa fa-circle fa-stack-2x text-primary"></i>
                        <i className="fa fa-pencil fa-5 fa-stack-1x fa-inverse"></i>
                      </span>
                      <h4 className="service-heading">Individuelle Planung und Beratung</h4>
                    </div>
                    <div className="col-md-6">
                      <span className="fa-stack fa-3x">
                        <i className="fa fa-circle fa-stack-2x text-primary"></i>
                        <i className="fa fa-check fa-5 fa-stack-1x fa-inverse"></i>
                      </span>
                      <h4 className="service-heading">Installation, Anmeldung und Inbetriebnahme</h4>
                    </div>
                  </div>
                </div>
              </div>
            </respond-html>
          </div>
        </div>
        <div id="hersteller banner" className="block row" data-nested="not-nested" data-containerid="" data-containercssclass="">
          <div className="col col-md-12">
            <respond-html id="html-4" description="HTML">
              <div className="hersteller-section">
                <div className="row">
                  <div className="col-md-12 text-center">
                      <img alt="Vaillant Heizung" className="hersteller" src="files/photovoltaik/hersteller/vaillant.png" />
                      <img className="hersteller" src="files/photovoltaik/hersteller/solaredge.jpeg" />
                  </div>
                </div>
              </div>
            </respond-html>
          </div>
        </div>        
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/photovoltaik/Photovoltaik.js